import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPlus } = FiIcons;

const FloatingActionButton = ({ onClick }) => {
  return (
    <motion.button
      className="fixed bottom-6 right-6 p-4 rounded-full bg-primary-600 text-white shadow-lg z-40 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
      onClick={onClick}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      initial={{ opacity: 0, scale: 0 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ type: "spring", stiffness: 400, damping: 17 }}
    >
      <SafeIcon icon={FiPlus} className="h-6 w-6" />
    </motion.button>
  );
};

export default FloatingActionButton;